/**
 * Instantly pin a chat message list to the latest message.
 * Double-rAF + a short timeout cover layout that settles after the first paint
 * (flex panel height, markdown, images).
 */
export function pinChatScrollToBottom(el) {
  if (!el) return;
  const pin = () => {
    el.scrollTop = el.scrollHeight;
  };
  pin();
  requestAnimationFrame(() => {
    pin();
    requestAnimationFrame(pin);
  });
  // Flex parents often get their final height a tick after mount.
  window.setTimeout(pin, 0);
  window.setTimeout(pin, 50);
}
